import { useCallback } from 'react';
import { useValuationsStore } from '@/pages/ValuationsV2/store/valuationsStore';
import type { Asset } from '@/types/GraphqlSchema';
import { useMutateWatchList } from './useMutateWatchList';
import { useQueryVariables } from './useQueryVariables';
import { useWatchList } from './useWatchList';

const useHandleWatchList = () => {
  const variables = useQueryVariables();
  const { refetch } = useWatchList(variables);
  const { removeFromWatchList, addToWatchList } = useMutateWatchList();
  const watchlistAssetIds = useValuationsStore.use.watchlistAssetIds();

  const isInWatchList = useCallback(
    (id: Asset['id']): boolean => {
      return watchlistAssetIds.has(id);
    },
    [watchlistAssetIds],
  );

  const toggleWatchList = useCallback(
    async (asset: Asset) => {
      const assetLegacyId = asset.legacyId;
      const assetIsoCode = asset.country?.isoCode;

      if (!assetLegacyId || !assetIsoCode) {
        return;
      }

      const isAssetInWatchList = isInWatchList(asset.id);

      try {
        if (isAssetInWatchList) {
          await removeFromWatchList(assetLegacyId, assetIsoCode);
        } else {
          await addToWatchList(assetLegacyId, assetIsoCode);
        }
        await refetch();
      } catch (error) {
        console.error('Failed to toggle watchlist', error);
      }
    },
    [isInWatchList, addToWatchList, removeFromWatchList, refetch],
  );

  return {
    toggleWatchList,
    isInWatchList,
  };
};

export { useHandleWatchList };
